import { render, staticRenderFns } from "./TutorLogin.vue?vue&type=template&id=72559410&scoped=true"
import script from "./TutorLogin.vue?vue&type=script&lang=js"
export * from "./TutorLogin.vue?vue&type=script&lang=js"
import style0 from "./TutorLogin.vue?vue&type=style&index=0&id=72559410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72559410",
  null
  
)

export default component.exports